import React from 'react';
import { useEffect } from 'react';
import Footer from '../footer/footer';
import Games from '../games/games';
import Header from '../header/header';
import styles from './main.module.css';
const Main = ({game}) => {
    useEffect(()=> {
        let ins = document.createElement('ins');
        let scr = document.createElement('script');

        ins.className = 'kakao_ad_area';
        ins.style = "display:none;";
        scr.async = 'true';
        scr.type = "text/javascript";
        scr.src = "//t1.daumcdn.net/kas/static/ba.min.js";
        ins.setAttribute('data-ad-width', '320');
        ins.setAttribute('data-ad-height', '100');
        ins.setAttribute('data-ad-unit', 'DAN-aMwDDc45vvdBFbJl');

        document.querySelector('.adfit').appendChild(ins);
        document.querySelector('.adfit').appendChild(scr);
    })
    return (
        <>
        <div className={styles.container}>
            <Header />
            <Games game={game}/>
            <Footer />
            <div className="adfit"/>
            </div>
        </>
    )
}

export default Main;